module.exports = __webpack_public_path__ + "img/18.2.TN.48e0bdff.png";